module.exports = __webpack_public_path__ + "static/media/redo.9f7708af.svg";